import React from 'react';

function ContactPage() {
  return (
    <section className="min-h-[80vh] bg-[#f7fafd] py-20 px-4 md:px-0 flex flex-col items-center">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8 animate-fadeIn">
        <h1 className="text-3xl font-bold text-blue-900 mb-2 text-center">Contactez-nous</h1>
        <p className="text-blue-700 text-center mb-8">Une question, une demande de démo ou un partenariat ? Écrivez-nous, nous vous répondrons sous 24h.</p>
        <form className="flex flex-col gap-4 mb-6">
          <input type="text" placeholder="Votre nom" className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300" required />
          <input type="email" placeholder="Votre email" className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300" required />
          <textarea placeholder="Votre message" className="border rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-300" rows={5} required></textarea>
          <button type="submit" className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-lg font-semibold text-lg hover:from-blue-600 hover:to-purple-600 transition transform hover:scale-105 hover:shadow-2xl">Envoyer</button>
        </form>
        <div className="text-center text-blue-700 text-sm mb-2">
          <div><p className="underline">Email: contact@kora.app</p></div>
          <div>LinkedIn : <button type="button" className="underline hover:text-blue-500 bg-transparent border-none p-0 m-0 cursor-pointer">Lien LinkedIn</button></div>
        </div>
        <div className="mt-6 bg-blue-50 rounded-lg p-4 text-blue-800 text-center text-xs">
          <span className="font-semibold">Confidentialité :</span> Vos données ne sont jamais revendues ni exploitées à des fins commerciales. Nous répondons à toutes les demandes sous 24h ouvrées.
        </div>
      </div>
    </section>
  );
}

export default ContactPage; 